import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from '../static/theme/languages/en.js'
import axios from 'axios'

/**
 * Helper script to setup and support localisation
 */

/* setup localisation defaulting to english  */
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'en',
  messages,
  fallbackLocale: 'en'
})

const loadedLanguages = ['en'] // our default language that is prelaoded

/**
 * Helper to switch language
 * @param {string} lang - iso language code to switch to.
 * @returns {*} lang for convenience
 */
function setI18nLanguage (lang) {
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

/**
 * Function to lazy load a language and switch HTTP and locale strings to it
 * @param {string} lang - the language iso to switch to
 * @returns {Promise<any>}
 */
export function loadLanguageAsync (lang) {
  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      return import(`../static/theme/languages/${lang}.js`).then(msgs => {
        i18n.setLocaleMessage(lang, msgs.default)
        loadedLanguages.push(lang)
        return setI18nLanguage(lang)
      })
    }
    return Promise.resolve(setI18nLanguage(lang))
  }
  return Promise.resolve(lang)
}

export default i18n
